
// Vue
import { Component, Mixins } from 'vue-mixin-decorator';
// Components
import BasePage from '@/pages/BasePage.vue';
// CMS
import { Tos } from '@/apis/cms';
// lodash
import orderBy from 'lodash/orderBy';

import { AltContents } from '@/common/alternatives';

@Component
export default class TermsPage extends Mixins<BasePage>(BasePage) {
  private terms: Array<Tos> = [];
  private selectedTerm: Tos = {} as Tos;

  async created() {
    this.store.showLoader();

    this.terms = await this.getTerms();
    this.selectedTerm = this.terms[0];

    if (this.$route.query.term !== undefined) {
      const term = this.terms.find(e => e.id == this.$route.query.term);
      if (term) this.selectedTerm = term;
    }

    this.store.hideLoader();
  }

  /**
   * 表示する規約を切り替える
   *
   * @param 選択された規約のコンテンツID
   */
  private changeTerm(id: string) {
    this.selectedTerm = this.terms.find(t => {
      return t.id === id;
    })!;
  }

  /**
   * CMSから利用規約を取得する
   */
  private async getTerms() {
    const httpClient = await this.$cmsClient();
    const terms = await httpClient.tos
      .getTos()
      .then(res => {
        const { data } = res;
        if (data.contents.length < 1) {
          return AltContents.ToSResponse;
        }
        return data;
      })
      .catch(() => {
        return AltContents.ToSResponse;
      });

    return orderBy(terms.contents, 'order');
  }
}
